/* eslint-disable react/style-prop-object */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

export default function MasterPage({ state, children }) {
   
    return (
        <>
            {/* Meta Tags */}
            <title>{state.metaTitle}</title>
            <meta name="description" content={state.metaDesc} />
            <meta name="keywords" content={state.metaKey} />
            <meta name="description" content={state.metaDesc} />
            <meta name="author" content={state.mauthor} />
            <meta name="keywords" content={state.metaKey} />
            <meta name="robots" content="index, follow" />

            <meta property="og:locale" content="en_US" />
            <meta property="og:title" content={state.metaTitle } />
            <meta property="og:url" content="#" />
            <meta property="og:type" content={state.Ogtype} />
            <meta property="og:description" content={state.metaDesc} />
            <meta property="og:site_name" content={state.ogsite } />

            <meta name="twitter:card" content="summary" />
            <meta name="twitter:title" content={state.metaTitle} />
            <meta name="twitter:description" content={state.metaDesc } />
            <meta name="twitter:url" content="#" />

            <section id="topbar" className="d-none d-lg-block">
                <div className="container clearfix">
                    <div className="contact-info float-left">
                        <i className="fas fa-envelope-o"></i> <a href="mailto:info@tejaxo.com">info@tejaxo.com</a>
                        <i className="fas fa-phone"></i> +91 9999565112
                    </div>
                    <div className="social-links float-right">
                        <a href="https://twitter.com/tejaxotech" className="twitter"><i className="fab fa-twitter"></i></a>
                        <a href="https://www.facebook.com/Tejaxo-103061388440469" className="facebook"><i className="fab fa-facebook-square"></i></a>
                        <a href="https://www.linkedin.com/company/tejaxo-technologies" className="linkedin"><i className="fab fa-linkedin"></i></a>
                    </div>
                </div>
            </section>

            <div className="wsmobileheader clearfix">
                <a id="wsnavtoggle" className="wsanimated-arrow"><span></span></a>
                <span className="smllogo"><img src="images/menu-logo.png" width="80" alt="" /></span>
                <a href="tel:+919999565112" className="callusbtn"><i className="fas fa-phone"></i></a>
            </div>

            <div class="wsmainfull clearfix">
                <div class="wsmainwp clearfix right">
                    <nav class="wsmenu clearfix">

                        <ul class="wsmenu-list">
                            <li aria-haspopup="true" style={{ minWidth: '500px', textAlign: 'left!important', backgroundColor: 'white' }} ><a href="/">
                                <img src="theme/img/t_logo.jpg" style={{ maxWidth: '200px' }} alt=""></img></a></li>
                            <li aria-haspopup="true"><a href="/" class="active wshomeico"><i class="fas fa-home"></i> Home</a></li>
                            <li aria-haspopup="true">
                                <a href="#"><i class="fas fa-align-justify"></i> Company <span class="wsarrow"></span></a>
                                <ul class="sub-menu">
                                    <li aria-haspopup="true"><a href="about"><i class="fas fa-angle-right"></i>About Tejaxo Software </a></li>

                                </ul>
                            </li>
                            <li aria-haspopup="true">
                                <a href="#"><i class="fas fa-list-alt"></i>Industries<span class="wsarrow"></span></a>

                                <div class="wsmegamenu clearfix halfmenu">
                                    <div class="container-fluid">
                                        <div class="row" style={{ overflow: 'scroll' }} >
                                            <ul class="col-lg-6 col-md-12 col-xs-12 link-list">
                                                <li class="title">Core Industries</li>
                                                <li><a href="printing-packaging"><i class="fas fa-arrow-circle-right"></i>Printing & Packaging</a></li>
                                                <li><a href="chemicals-paper-and-rubber-industry"><i class="fas fa-arrow-circle-right"></i>Chemical Paper & Ruber</a></li>
                                                <li><a href="automotive-industry"><i class="fas fa-arrow-circle-right"></i>Automotive</a></li>
                                                <li><a href="pharmaceuticals-industry"><i class="fas fa-arrow-circle-right"></i>Pharmaceuticals</a></li>
                                                <li><a href="building-material-suppliers"><i class="fas fa-arrow-circle-right"></i>Construction</a></li>
                                            </ul>
                                            <ul class="col-lg-6 col-md-12 col-xs-12 link-list">
                                                <li class="title">Other Industies Supported</li>
                                                <li><a href="food-beverage-industry"><i class="fas fa-arrow-circle-right"></i>Food & Beverage</a></li>
                                                {/*<li><a href="fashion-industry"><i class="fas fa-arrow-circle-right"></i>Fashion </a></li>*/}
                                                <li><a href="transportation-industry"><i class="fas fa-arrow-circle-right"></i>Transportation </a></li>
                                                <li><a href="machinery-and-equipment-industry"><i class="fas fa-arrow-circle-right"></i>Machinery & Equipment </a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <li aria-haspopup="true">
                                <a href="#"><i class="fas fa-list-ul"></i> Product & Services <span class="wsarrow"></span></a>
                                <div class="wsmegamenu clearfix">
                                    <div class="container-fluid">
                                        <div class="row" style={{ overflow: 'scroll' }} >
                                            <ul class="col-lg-offset-2 col-lg-3 col-md-12 col-xs-12 link-list">
                                                <li class="title">Core ERP</li>
                                                <li><a href="tejaxo-erp"><i class="fas fa-arrow-circle-right"></i>Tejaxo Basic ERP </a></li>
                                                <li><a href="tejaxo-ready-cloud-erp"><i class="fas fa-arrow-circle-right"></i>Tejaxo Cloud Solution </a></li>
                                                <li><a href="tejaxo-crm"><i class="fas fa-arrow-circle-right"></i>Tejaxo CRM</a></li>
                                                <li><a href="business-intelligence-applications"><i class="fas fa-arrow-circle-right"></i>Tejaxo BI Embedded ERP</a></li>
                                                {/*<li><a href="school-management"><i class="fas fa-arrow-circle-right"></i>School ERP</a></li>*/}
                                                {/*<li><a href="collage-management"><i class="fas fa-arrow-circle-right"></i>College ERP</a></li>*/}
                                              
                                            </ul>
                                            <ul class="col-lg-3 col-md-12 col-xs-12 link-list">
                                                <li class="title">Services</li>
                                                {/*<li><a href="cloud"><i class="fas fa-arrow-circle-right"></i>Cloud</a></li>*/}
                                                <li><a href="digital-commerce"><i class="fas fa-arrow-circle-right"></i>Digital Service</a></li>
                                                <li><a href="business-intelligence"><i class="fas fa-arrow-circle-right"></i>Business Intelligence</a></li>
                                                {/*<li><a href="vendor-management-portal"><i class="fas fa-arrow-circle-right"></i>SAP/Microsoft Dynamics AX Integrated Portals</a></li>*/}
                                                {/*<li><a href="robotic_process_automation"><i class="fas fa-arrow-circle-right"></i>Robotic Process Automation (Power Automate)</a></li>*/}
                                                {/*<li><a href="http://hncs.co.in"><i class="fas fa-arrow-circle-right"></i>Man Power Consultancy</a></li>*/}
                                                {/*<li><a href="http://www.pocketdriver.in"><i class="fas fa-arrow-circle-right"></i>Driver Service Consultancy</a></li>*/}
                                                <li><a href="erp-implementation"><i class="fas fa-arrow-circle-right"></i>ERP Implementation</a></li>
                                               
                                            </ul>
                                            <ul class="col-lg-3 col-md-12 col-xs-12 link-list">
                                                <li class="title">Other Products</li>
                                                <li><a href="dsc"><i class="fas fa-arrow-circle-right"></i>DSC Signer</a></li>
                                                <li><a href="bio-metrics-integration"><i class="fas fa-arrow-circle-right"></i>Punching Machine Integration</a></li>
                                                <li><a href="document-managemnet-system"><i class="fas fa-arrow-circle-right"></i>Document Managemnet System</a></li>
                                                <li><a href="vendor-management-portal"><i class="fas fa-arrow-circle-right"></i>Vendor Portal</a></li>
                                                <li><a href="cust-management-portal"><i class="fas fa-arrow-circle-right"></i>Customer Portal</a></li>
                                                <li><a href="new-product-developement"><i class="fas fa-arrow-circle-right"></i>New Product Development Module</a></li>
                                                {/*<li><a href="new-vendor-developement"><i class="fas fa-arrow-circle-right"></i>New Vendor Development Module</a></li>*/}
                                                {/*<li><a href="meeting-organiser"><i class="fas fa-arrow-circle-right"></i>Meeting Organiser</a></li>*/}
                                                <li><a href="online-test"><i class="fas fa-arrow-circle-right"></i>Online Test</a></li>
                                            </ul>
                                            <ul class="col-lg-3 col-md-12 col-xs-12 link-list">
                                                <li class="title">Other Products</li>
                                                {/*<li><a href="banquet-hall"><i class="fas fa-arrow-circle-right"></i>Banquet Hall</a></li>*/}
                                                {/*<li><a href="event-management"><i class="fas fa-arrow-circle-right"></i>Event Management</a></li>*/}
                                                {/*<li><a href="front-desk"><i class="fas fa-arrow-circle-right"></i>Front Desk</a></li>*/}
                                                {/*<li><a href="hostal-management"><i class="fas fa-arrow-circle-right"></i>Hostel Management</a></li>*/}
                                                <li><a href="employee-self-services"><i class="fas fa-arrow-circle-right"></i>Employee Self Services</a></li>
                                                {/*<li><a href="knowledge-repository"><i class="fas fa-arrow-circle-right"></i>knowledge Repository</a></li>*/}
                                                {/*<li><a href="library-management"><i class="fas fa-arrow-circle-right"></i>Library</a></li>*/}
                                                {/*<li><a href="parent-portal"><i class="fas fa-arrow-circle-right"></i>Parent Portal</a></li>*/}
                                                {/*<li><a href="question-paper-designer"><i class="fas fa-arrow-circle-right"></i>Question Paper Designer</a></li>*/}
                                                <li><a href="tally-integration"><i class="fas fa-arrow-circle-right"></i>Tally Integration</a></li>
                                            </ul>

                                        </div>
                                    </div>
                                </div>
                            </li>

                            <li aria-haspopup="true" id="litop">
                                <a href="#" id="topc"><i class="fas fa-paper-plane"></i> Contact Us <span class="wsarrow"></span></a>
                                <div class="wsmegamenu halfdiv">
                                    <div class="container-fluid">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <h3 class="title">Contact Form</h3>
                                                <form name="contact_name" class="menu_form">
                                                    <input type="text" placeholder="Name" id="txt_name" required></input>
                                                        <input type="text" placeholder="Email" id="txt_email" required></input>
                                                            <input type="text" placeholder="phone" id="txt_phone"></input>
                                                                <textarea placeholder="Your message..." id="txt_msg"></textarea>
                                                                <input type="button" value="Reset"></input>
                                                                    <input type="button" onclick="saveme(this,'Top')" value="Send"></input>
                                                                    </form>
                                                                    <div class="cl"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li aria-haspopup="true"><a href="https://sso.godaddy.com/v1?region=am2&saas=0&app=ox&path=v1%2Fsaml%2Fox&realm=pass&status=24" class="active wshomeico"><i class="fas fa-mail-bulk"></i> Login</a></li>
                                            </ul>
                                        </nav>


                                    </div>
                                </div>

            {children}
            <section id="contact" className="wow fadeInUp">
                <div className="container">
                    <div className="section-header">
                        <h2>Contact Us</h2>
                    </div>
                    <div className="row contact-info">
                        <div className="col-lg-5">
                            <div className="contact-address">
                                <i className="ion-ios-location-outline"></i>
                                <h3>Address</h3>
                                <address>1st Floor,6670/1-A-G,Bali Nagar,Agra Chowk, New Colony Road, near Haryana Public School, Camp Market, Palwal, Haryana 121102</address>
                                
                            </div>
                            <div className="contact-phone">
                                <i className="ion-ios-telephone-outline"></i>
                                <h3>Phone Number</h3>
                                <p><a href="tel:+919999565112">+91 9999565112</a></p>
                            </div>
                            <div className="contact-email">
                                <i className="ion-ios-email-outline"></i>
                                <h3>Email</h3>
                                <p><a href="mailto:info@tejaxo.com">info@tejaxo.com</a></p>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="form">
                                <form id="contactForm">
                                    <div className="form-group">
                                        <input type="text" className="form-control" placeholder="Full Name" id="txt_name" required />
                                    </div>
                                    <div className="form-group">
                                        <input type="email" className="form-control" placeholder="Email" id="txt_email" required />
                                    </div>
                                    <div className="form-group">
                                        <input type="text" className="form-control" placeholder="Mobile" id="txt_phone" required />
                                    </div>
                                    <div className="form-group">
                                        <textarea className="form-control" placeholder="Message" id="txt_msg" required></textarea>
                                    </div>
                                    <button type="submit" className="btn btn-primary pull-right">Send</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container mb-4 map">
                    <iframe
                        src="https://maps.google.com/maps?q=28.1392098,77.3210593&hl=en&z=14&amp;output=embed"
                        width="100%" height="350" frameBorder="0" style={{ border: '0' }} allowFullScreen
                    ></iframe>
                </div>
            </section>

            <section id="call-to-action" className="wow fadeInUp" style={{ backgroundColor: '#d68a0a' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9 text-center text-lg-left">
                            <h3 className="cta-title">Get Our Service</h3>
                            <p className="cta-text">
                                Catch up on industry trends, Tejaxo Software news & more...
                            </p>
                        </div>
                        <div className="col-lg-3 cta-btn-container text-center">
                            <a className="cta-btn align-middle" href="#contact">Contact Us</a>
                        </div>
                    </div>
                </div>
            </section>

            <footer id="footer">
                <div className="container">
                    <div className="copyright">
                        &copy; Copyright <strong>Pocketdriver</strong>. All Rights Reserved
                    </div>
                    <div className="credits">
                        Designed By <a href="http://www.tejaxo.com/">Tejaxo Technologies Pvt.Ltd.</a>
                    </div>
                </div>
            </footer>

            <a href="#" className="back-to-top"><i className="fas fa-chevron-up"></i></a>
        </>
    );
}
